export const trackUmamiEvent = (name: string, data?: Record<string, unknown>) => {
  if (typeof window === 'undefined') return;

  const umami = (
    window as Window & {
      umami?: { track: (event: string, eventData?: Record<string, unknown>) => void };
    }
  ).umami;

  if (umami?.track) {
    umami.track(name, data);
  }
};
